import React, { useState } from 'react';
import { BaseConfigModal } from './BaseConfigModal';

interface SplunkConfigModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'add' | 'configure';
  integration?: {
    id: string;
    name: string;
    description: string;
    icon: string;
    connected: boolean;
  };
}

export const SplunkConfigModal: React.FC<SplunkConfigModalProps> = ({
  isOpen,
  onClose,
  type,
  integration
}) => {
  const [hostUrl, setHostUrl] = useState('');
  const [apiToken, setApiToken] = useState('');
  const [indexName, setIndexName] = useState('');
  const [workspaceName, setWorkspaceName] = useState('');
  const [showDisconnectConfirm, setShowDisconnectConfirm] = useState(false);

  const handleSubmit = () => {
    // Handle form submission
    console.log('Form submitted:', { hostUrl, apiToken, indexName, workspaceName });
    onClose();
  };

  const handleDisconnect = () => {
    // Handle disconnect action
    console.log('Disconnecting integration:', integration?.id);
    setShowDisconnectConfirm(false);
    onClose();
  };

  if (showDisconnectConfirm) {
    return (
      <BaseConfigModal
        isOpen={true}
        onClose={() => setShowDisconnectConfirm(false)}
        title="Disconnect Integration"
        icon={integration?.icon}
        onSubmit={handleDisconnect}
        submitText="Disconnect"
      >
        <p className="text-gray-400 mb-4">
          Are you sure you want to disconnect this integration? This action cannot be undone.
        </p>
      </BaseConfigModal>
    );
  }

  return (
    <BaseConfigModal
      isOpen={isOpen}
      onClose={onClose}
      title={type === 'add' ? 'Add Splunk Integration' : `Configure ${integration?.name}`}
      icon={integration?.icon}
      onSubmit={handleSubmit}
      submitText={type === 'add' ? 'Add Integration' : 'Save Changes'}
    >
      {type === 'add' && (
        <div className="space-y-2">
          <label className="text-sm text-gray-400">Workspace Name</label>
          <input
            type="text"
            value={workspaceName}
            onChange={(e) => setWorkspaceName(e.target.value)}
            className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500"
            placeholder="Enter workspace name"
          />
        </div>
      )}

      <div className="space-y-2">
        <label className="text-sm text-gray-400">Splunk Host URL</label>
        <input
          type="text"
          value={hostUrl}
          onChange={(e) => setHostUrl(e.target.value)}
          className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500"
          placeholder="https://your-splunk-instance.com:8089"
        />
      </div>

      <div className="space-y-2">
        <label className="text-sm text-gray-400">API Token</label>
        <input
          type="password"
          value={apiToken}
          onChange={(e) => setApiToken(e.target.value)}
          className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500"
          placeholder="Enter your Splunk API token"
        />
      </div>

      <div className="space-y-2">
        <label className="text-sm text-gray-400">Index Name</label>
        <input
          type="text"
          value={indexName}
          onChange={(e) => setIndexName(e.target.value)}
          className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500"
          placeholder="main"
        />
      </div>

      {type === 'configure' && integration?.connected && (
        <div className="mt-6 pt-6 border-t border-gray-800">
          <button
            type="button"
            onClick={() => setShowDisconnectConfirm(true)}
            className="w-full px-4 py-2 bg-red-500/10 text-red-500 rounded-lg hover:bg-red-500/20 transition-colors"
          >
            Disconnect Integration
          </button>
        </div>
      )}
    </BaseConfigModal>
  );
};